import { AdminFeedbackSession, AdminNote } from '../../types/types';
import { NotesList } from '../../components/Admin/NotesList';
import { AdminNotesLoader } from '../../loaders/AdminNotesLoader';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AdminFeedbackSessionsLoader } from '../../loaders/AdminFeedbackSessionsLoader';
import { FeedbackSessionsList } from '../../components/Admin/FeedbackSessionsList';

export const FeedbackOverview: React.FC = () => {
  const { user_id } = useParams<{ user_id?: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [feedbackSessions, setFeedbackSessions] = useState<AdminFeedbackSession[] | null>();
  const [page, setPage] = useState(0);
  const [perPage] = useState(100);
  const [sortField, setSortField] = useState('last_modified');
  const [sortDirection, setSortDirection] = useState(-1);

  const fetchFeedbackSessionsData = async () => {
    setIsLoading(true);
    const response = await AdminFeedbackSessionsLoader(
      page,
      perPage,
      user_id,
      sortField,
      sortDirection,
    );
    if (response) {
      setIsLoading(false);
      console.log(response);
      setFeedbackSessions(response);
    }
  };

  const handlePageChange = (newPage: number) => {
    setPage(Math.max(0, newPage));
  };

  const handleSortChange = (field: string) => {
    if (field === sortField) {
      // Toggle sort direction if the field is the same
      setSortDirection(sortDirection === -1 ? 1 : -1);
    } else {
      // Default to ascending sort for a new field
      setSortField(field);
      setSortDirection(sortDirection === -1 ? 1 : -1);
    }
  };

  useEffect(() => {
    fetchFeedbackSessionsData();
  }, [page, perPage, sortField, sortDirection]);

  if (isLoading) return <div>Loading...</div>;

  return (
    <div className="flex">
      <div className="w-3/4 min-w-0 overflow-x-auto">
        <div>
          Feedback {page} – {page + perPage}
        </div>
        <FeedbackSessionsList
          feedbackSessionsList={feedbackSessions!}
          handleSortChange={handleSortChange}
        />
        <div className="flex justify-between">
          <button onClick={() => handlePageChange(page - 100)}>Previous Page</button>
          <button onClick={() => handlePageChange(page + 100)}>Next Page</button>
        </div>
      </div>
    </div>
  );
};
